import { useState } from "react"

import { produce } from "immer"
import { HxMapGroup } from "../../../../Comps/HxMap/HxMapGroup"
import { HxNote } from "../../../../Comps/HxMap/HxNote"
import { NotesSelectMenu } from "../../../../Comps/NoteButtons/NotesSelect"
import { HexMap } from "../../../../Data/HexMap/HexMap"
import { HexMapBuilderParams, BuildHexMap } from "../../../../Data/HexMap/HexMapBuilder"
import { HexMapModifier } from "../../../../Data/HexMap/HexMapModifier"
import { Note } from "../../../../Data/HexMap/Note"
import { FlexRowTwo } from "../../../../Layouts/FlexRows"
import { useNoteNames } from "../../../../Project/ProjectStore"
import { All } from "../../../../Util/Constants/Quantities"
import { Music, useScaleNotes } from "../../../../Util/Music/Music"
import { TransformTranslate } from "../../../../Util/Transform/Transform"
import { IconEye } from "../../../../Comps/Icons/IconEye"
import { CommonNotes } from "../CommonNotes"

export function CycleOfFlatThirdsPair(){ 
    const [tonic, setTonic] = useState(Music.G)
    const getAdjustedTonic = (t:number) => { return t }
    const getMap = () => {
        const params:HexMapBuilderParams = {rows:1, columns:2, tonic:getAdjustedTonic(tonic), radius:80}
        const map:HexMap = BuildHexMap(params)
        const mod:HexMapModifier = new HexMapModifier(map)
        mod.keys_setOpen([All], true)
        //mod.notes_setPrimaryLabelAsNoteIndex([All])
        return map
    }
    const [map, setMap] = useState<HexMap>(getMap())
    const [width,height] = [350,300]
    const onNoteClick = (note:Note) => {
        setMap(produce((draft:HexMap)=>{
            const mod:HexMapModifier = new HexMapModifier(draft)
            mod.notes_advanceSelectedState([note.params.noteIndex])
        }))
    }
    const resetTonic = (t:number) => {
        setFlatSixthsVisible(false)
        setTonic(t)
        setMap(produce((draft:HexMap)=>{
            const mod:HexMapModifier = new HexMapModifier(draft)
            mod.setTonic(getAdjustedTonic(t))
        }))
    }
    const commonNoteIndexes:number[] = [1,2,5,6,7,8]
    const showCommonNotes = () => {
        setFlatSixthsVisible(false)
        const noteIndexes:number[] = commonNoteIndexes
        setMap(produce((draft:HexMap)=>{
            const mod:HexMapModifier = new HexMapModifier(draft)
            mod.notes_setDefault([All])
            mod.notes_setSelected(noteIndexes)
        }))
    }
    const showCommonChords = () => {
        setFlatSixthsVisible(false)
        const noteIndexes:number[] = []
        setMap(produce((draft:HexMap)=>{
            const mod:HexMapModifier = new HexMapModifier(draft)
            mod.notes_setDefault([All])
            mod.notes_setHilited(noteIndexes)
        }))
    }
    const showSus2 = () => {
        setFlatSixthsVisible(false)
        const noteIndexes:number[] = [5,6,2,7,8]
        setMap(produce((draft:HexMap)=>{
            const mod:HexMapModifier = new HexMapModifier(draft)
            mod.notes_setDefault([All])
            mod.notes_setHilited(noteIndexes)
        }))
    }
    const showAltSus2 = () => {
        setFlatSixthsVisible(false)
        const noteIndexes:number[] = [1,2,5,7]
        setMap(produce((draft:HexMap)=>{
            const mod:HexMapModifier = new HexMapModifier(draft)
            mod.notes_setDefault([All])
            mod.notes_setHilited(noteIndexes)
        }))
    }
    const showNotes = (noteIndexes:number[]) => {
        setFlatSixthsVisible(false)
        setMap(produce((draft:HexMap)=>{
            const mod:HexMapModifier = new HexMapModifier(draft)
            mod.notes_setDefault([All])
            mod.notes_setHilited(noteIndexes)
        }))
    }
    const noteNames:string[] = useNoteNames()
    const leftTonicNote:string = noteNames[tonic]
    const rightTonic:number = (tonic + 9) % 12
    const rightTonicNote:string = noteNames[rightTonic]
    const scale:string[] = useScaleNotes(tonic)
    const scaleRight:string[] = useScaleNotes(rightTonic)

    const clear = () => {
        setFlatSixthsVisible(false)
        setMap(getMap())
    }
    const [flatSixthsVisible, setFlatSixthsVisible] = useState(false)
    const showFlatSixths = () => {
        setFlatSixthsVisible(true)
        setMap(produce((draft:HexMap)=>{
            const mod:HexMapModifier = new HexMapModifier(draft)
            mod.notes_setDefault([All])
            mod.notes_setHilited([1,3,6,11,8])
        }))
    }
    const getFirstFlatSixth = () => {
        if(!flatSixthsVisible){return}
        const getX = () => {
            return (map.notes[4].params.x + map.notes[5].params.x)/2
        }
        const getY = () => {
            return (map.notes[4].params.y + map.notes[5].params.y)/2
        }
        const getTonic = () => {
            return (map.notes[4].params.tonic + 1) % 12
        }
        const note:Note = new Note({noteIndex:100, x:getX(), y:getY(), tonic:getTonic()})
        note.classNames = ['hilited', 'flat-sixth']
        return <HxNote onNoteClick={onNoteClick} classNames={['blue-note']} note={note}/>  
    }
   const getSecondFlatSixth = () => {
        if(!flatSixthsVisible){return}
        const getX = () => {
            return (map.notes[2].params.x + map.notes[10].params.x)/2
        }
        const getY = () => {
            return (map.notes[2].params.y + map.notes[10].params.y)/2
        }
        const getTonic = () => {
            return (map.notes[2].params.tonic + 1) % 12
        }
        const note:Note = new Note({noteIndex:100, x:getX(), y:getY(), tonic:getTonic()})
        note.classNames = ['hilited', 'flat-sixth']
        return <HxNote onNoteClick={onNoteClick} classNames={['blue-note']} note={note}/>  
    }
    const showMinorChain = () => {
        setFlatSixthsVisible(false)
        setMap(produce((draft:HexMap)=>{
            const mod:HexMapModifier = new HexMapModifier(draft)
            mod.notes_setDefault([All])
            mod.notes_setHilited([1,2,10])
        }))    
    }
    return(
        <div className={'harmonic-cycle-pair'}>
            <FlexRowTwo columnOneFlex={1} columnTwoFlex={1}>
               <div className={'centered'} style={{marginTop:30}}> 
                    <div><NotesSelectMenu onChange={resetTonic} tonic={tonic}/></div>
                    <svg width={width} height={height} className={'pair-hexmap'}>
                        <g transform={TransformTranslate(width/2, height/2)}>
                            <HxMapGroup hexMap={map} onNoteClick={onNoteClick}>
                                {getFirstFlatSixth()}
                                {getSecondFlatSixth()}
                            </HxMapGroup>
                        </g>
                    </svg>
                    <div><button style={{marginTop:25}} type='button' onClick={clear}>Clear</button></div>
                </div>
                <div className={'pair-description'}>
                    <h2>Properties of Two Keys Along a Cycle of Flat Thirds</h2>
                    <ul>
                        <li>Common Notes: 4 of 7 <CommonNotes map={map} noteIndexes={commonNoteIndexes}/> <IconEye onClick={showCommonNotes}/></li>
                        <li>Common Triadic Chords: 0 of 7<IconEye onClick={showCommonChords}/></li>
                        <li>    
                            Common Sus Chords: {scale[5]} Sus2 & {scale[2]} Sus4 <IconEye onClick={showSus2}/>, {scale[1]} Sus2 & {scale[5]} Sus4 <IconEye onClick={showAltSus2}/>
                        
                        </li>
                        <li>The left key ({leftTonicNote}) is a flat third (3 notes) higher than the right key ({rightTonicNote}).</li>
                        <li>Conversely, the right key ({rightTonicNote}) is a sixth (9 notes) higher than the left key ({leftTonicNote})</li>   
                    </ul>
                    <h2>Common Modulation Techniques:</h2>
                    <ul>
                        <li>Switching parallel modes from {scale[5]} Aeolian to {scale[5]} Ionian, using {scale[2]} major</li>
                        <li>Chaining minor chords: {scale[1]}min, {scale[2]}min and {scaleRight[5]}min. <IconEye onClick={showMinorChain}/></li>
                        <li>Using full-diminished chords. <IconEye onClick={showFlatSixths}/></li>
                    </ul>
                    <h2>Parallel Modes (top key to bottom key):</h2>
                    <ul>
                        <li>
                            {scale[1]} Dorian in {leftTonicNote} and {scale[1]} Lydian in {rightTonicNote} 
                            <IconEye onClick={()=>{showNotes([1])}}/>
                        </li>
                        <li>
                            {scale[1]} Phrygian in {leftTonicNote} and {scale[1]} Mixolydian in {rightTonicNote} 
                            <IconEye onClick={()=>{showNotes([2])}}/>
                        </li>
                        <li>
                            {scale[5]} Aeolian (minor) in {leftTonicNote} and {scale[5]} Ionian (major) in {rightTonicNote} 
                            <IconEye onClick={()=>{showNotes([5,7])}}/>

                        </li>
                        <li>
                            {scale[6]} Locrian in {leftTonicNote} and {scale[6]} Dorian in {rightTonicNote} 
                            <IconEye onClick={()=>{showNotes([2])}}/>
                        </li>
                    </ul>
                </div>
            </FlexRowTwo>

        </div>
    )
}